import { render, staticRenderFns } from "./AllRequestText.vue?vue&type=template&id=aae32d38&lang=pug&"
import script from "./AllRequestText.vue?vue&type=script&lang=js&"
export * from "./AllRequestText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports